import React from 'react'
import icon from './svgs/chevron-down.svg'
import { BaseIcon } from './_base'

export const ChevronDownIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
